import {  useEffect, useState, useMemo } from "react";
import { nanoid } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { selectCurrentPage } from "context/pages/pageSlice";
import { useGetDistributersQuery } from "context/distributer/distributerApiSlice"; // useUpdateDistributerMutation
import { useMaterialUIController } from "context";
import { motion, AnimatePresence } from "framer-motion";
import parse from 'html-react-parser';
import DOMPurify from 'isomorphic-dompurify';
import { styled } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Paper from '@mui/material/Paper';
import Icon from '@mui/material/Icon';
import SearchIcon from '@mui/icons-material/Search';
import { Grid , IconButton, Divider, Card } from "@mui/material";
import MDBadge from "dashboard/components/MDBadge";
import MDBox from "dashboard/components/MDBox";
import MDAvatar from "dashboard/components/MDAvatar";
import MDTypography from "dashboard/components/MDTypography";
import MDInput from "dashboard/components/MDInput";
import MDPagination from "dashboard/components/MDPagination";
import MDAlert from "dashboard/components/MDAlert";
import loader from "assets/images/shapes/loader.svg";
import DistributerMap from "./components/DistributersMap";
import InfoCard from "components/Home/distributers/components/InfoCard";
import Navigation  from "components/Home/components/navigation";
import LandingFooter from "components/Home/components/landingFooter";
import CallToAction from "./components/CallToAction";
// Images
import useAlert from "hooks/useAlert";
import useSearch from "hooks/useSearch";
import  { ProvincesAutoComplete } from "hooks/useGeolocation";
import { StandardSelect } from "dashboard/examples/Forms/CostumFormFields/SelectMutipple";
/* eslint-disable */


const parseContent = content => parse(DOMPurify?.sanitize(content));
const  limitTextToWords = (text, maxWords = 100)=>{
  if(typeof text !== "string" ) return "...";
  // Split the text into an array of words
  const words = text.split(' ');

  // If the number of words is less than or equal to the limit, return the original text
  if (words.length <= maxWords) {
    return text;
  }

  // Otherwise, slice the array to get the first 'maxWords' words and join them back into a string
  const limitedText = words.slice(0, maxWords).join(' ');

  // Add an ellipsis (...) to indicate that the text has been truncated
  return limitedText + '...';
}
const DrawerHeader = styled('div')(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  }));

const variant = {
  hidden : {opacity : 0},
  visible: (index)=>({
    opacity :1,
    transition:{
      delay: .1 * Math.floor(index/3)
    }
  })
}

const MotionCard = motion(InfoCard);
let pageCount = 0;
let totalResult = 0;
let details;

const Distributers = () => {
  const [noMoreResults, setNoMoreResults] = useState(false);
  const [controller ] = useMaterialUIController();
  const { lang, filters } = controller;

  const pageContent = useSelector(selectCurrentPage);
  const [distributerList, setDistributerList] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const { showAlerts } = useAlert();
  const { searchTerm, filterSearch, unsetSearch } = useSearch();

  const distributersQuery = useMemo(
    () => {
      const filters = Object.fromEntries(Object.entries(searchTerm.filters).filter((item) => item[1] !== null && item[1] !== undefined && item[1] !== '' ));
      return({
      page: searchTerm.page,
      filters: JSON.stringify({...filters, lang }),
      distributersPerpage: searchTerm.entriesPerpage,
      sortBy:searchTerm.sortBy
     })},
    [searchTerm]
  );

  const {
    data: distributers = [],
    isLoading,
    isSuccess,
    isFetching,
    isError,
    error,
    
  } = useGetDistributersQuery(distributersQuery, {
      // pollingInterval: 60000,
      refetchOnMountOrArgChange: true,
      skip: noMoreResults
  });

  const getDistributers = distributersDetails => {
    filterSearch(distributersDetails);
  }

  useEffect(() => {
    if (isSuccess) {
      const { distributersDetails, entities } = distributers;
      const loadedList = Object.values(entities);
      details = distributersDetails;
      pageCount = Number(Math.ceil(distributersDetails?.total_results / distributersDetails?.distributersPerpage ));
      totalResult = distributersDetails?.total_results;
      setDistributerList(loadedList.length ? loadedList : null)
    }
  }, [isSuccess, distributers]);
  
  
  
  useEffect(() => {
    if(!distributers?.length && distributersQuery?.page > 1 ) {
      setNoMoreResults(true);
    }

    /* eslint-disable */
    isError ? showAlerts({
      title : "Dashboard Alert",
      type  : "toast",
      msg :  error.data?.error || error.message,
      color :"error"
    }) : null
  }, [isError]);

  let typingTimeout;

  const handleSearch = event => {
    const { target } = event;
    clearTimeout(typingTimeout);
    typingTimeout = setTimeout(()=> {
      filterSearch({ filters : {...searchTerm.filters, [target.name] : target.value} });
    }, 500);
  }

  const handleDistributorClick = (location) => {
    setSelectedLocation(location);
  };

  return (
    <>
       {pageContent.Navigation?.navBar && <Navigation parseContent={parseContent} data={{ navBar : pageContent.Navigation?.navBar, logo : pageContent.Navigation.logo?.selectedImage,  menu: pageContent.Menu }}  />}
      <Card
        sx={{
          px: { xs: 1, lg: 2 },
          mx: { xs: .5, lg: 3 },
          mt: 30,
          mb: 4,
          backgroundColor: ({ palette: { background }, functions: { rgba } }) => rgba(background.header, 0.8),
          backdropFilter: "saturate(200%) blur(30px)",
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
      <MDBox sx={{ display: 'flex'}}>
        <CssBaseline />
        {/* <DistributerSideBar filterSearch={filterSearch} open={open} setOpen={setOpen}/>
        <Divider sx={{mx: 0.5, height:'inherit'}}  orientation="vertical" /> */}
        <MDBox  component="main" sx={{ flexGrow: 1, minHeight : 200,  maxWidth:"100%"  }}>
            <DrawerHeader  my={1} p={2}>
              <Grid spacing={{xs:.5,lg:2}} alignItems="center" container>
                <Grid xs={12} md={6} lg={2} item> 
                <MDTypography variant="h4" >
                    Nos distributeurs <MDBadge badgeContent={totalResult} color="light" variant="gradient" size="sm" max={totalResult} />
                </MDTypography>
                </Grid>
                <Grid xs={12} md={6} lg={5} item>
                <Paper
                    component="div"
                    sx={{ p: '2px', display: 'flex', alignItems: 'center',  borderRadius:2}}
                    elevation={2}
                    >
                    <MDInput size="small" name="productName" value={filters?.productName}  onChange={handleSearch} type="search" placeholder="Rechercher un distributeur par produit." label="Nom du produit" fullWidth />
                    <IconButton type="button" sx={{ p: .6 }} aria-label="search">
                      <SearchIcon />
                    </IconButton>           
                </Paper>
                </Grid>
                <Grid xs={12} lg={2} item>
                  <ProvincesAutoComplete name={"province"} searchTerm={searchTerm} onChange={filterSearch} />
                </Grid>
                <Grid xs={9} lg={1.5} item>
                  <StandardSelect value={searchTerm.filters.radius}  samevalue textAlign="right" options={[0,15,25,50,100]} name="radius" onChange={handleSearch}/>
                </Grid>
              </Grid>          
            </DrawerHeader>
            <Divider/>
            <Grid container spacing={{xs:.6, lg:2}} justifyContent="space-between" >
              <Grid item xs={12} lg={5}>
              {(isLoading || isFetching ) && <MDAvatar display="flex" sx={{padding: 0,position: "absolute",zIndex: 9,top: "50%",left: "50%",transform: "translate3d(-24px, -20px, 0)"}}  
                      src={loader} alt="Avatar" variant="square" size="md" />}
              {distributerList && <AnimatePresence initial={false}>
                        <Grid spacing={{xs:.5,lg:2}} direction="row"  sx={{ p:{xs:.5,lg:2}, mb:1.5 }} container>
                          {distributerList.map( distributer => 
                            <MotionCard 
                              id={distributer.id}
                              color="secondary" 
                              key={distributer.id}
                              image={`${process.env.REACT_APP_PUBLIC_URL}/img/distributer/${distributer.photoURL}`}
                              title={distributer.companyName === "" || !distributer.companyName ? distributer.displayName : distributer.companyName}
                              telephone={distributer.telephone}
                              mobile={distributer.mobile}
                              email={distributer.email}
                              website={distributer.website}
                              address={parseContent(distributer.location?.street)}
                              province={parseContent(distributer.location?.state.province)}
                              handleDistributorClick={handleDistributorClick}
                              location={distributer.location?.coordinates?.lat ? {lat : distributer.location.coordinates.lat, lng : distributer.location.coordinates.lng} : null}
                              variants={variant}
                              initial="hidden"
                              animate="visible"
                            />)}
                        </Grid>
                </AnimatePresence>}
              {distributerList && pageCount > 1 ? (
                <MDBox my={2} >
                  <MDPagination size="medium" variant="gradient">
                    {details?.page > 0 && <MDPagination onClick={()=>getDistributers({page:details?.page - 1})} item>
                        <Icon>keyboard_arrow_left</Icon>
                    </MDPagination>}
                    {[...Array(pageCount)].map((x,i) => <MDPagination key={nanoid()} item onClick={()=>getDistributers({page:i})} active={details?.page === i}>{i+1}</MDPagination>)}    
                    {details?.page < pageCount -1 && <MDPagination onClick={()=>getDistributers({page:details?.page + 1})} item>
                        <Icon>keyboard_arrow_right</Icon>
                    </MDPagination>}
                  </MDPagination>
                </MDBox>
              ) : null}
              {(!distributerList && !isLoading) && <MDAlert color="info" sx={{my:3}} size="sm">{details?.filters.name !== '' || details?.filters.productName !=='' ?  "aucun résultat ne correspond à votre recherche" : "La list des produits est vide"}</MDAlert>} 
              </Grid>    
              <Grid item xs={12} lg={7} sx={{ display: "flex" }} >
                <Divider orientation="vertical" sx={{ ml: -2, mr: 3, height:"100%", display:{xs : "none", lg : "block"} }} />
                <DistributerMap selectedLocation={selectedLocation} searchTerm={searchTerm} filterSearch={filterSearch} distributerList={distributerList} parseContent={parseContent} />
              </Grid>
              <Divider sx={{width:"100%"}}/>
              <Grid item xs={12} lg={8}  >
                <MDBox sx={{px:{xs:1,lg:2}}}>
                    <MDBox sx={{ marginBottom: '20px' }}  >
                      <MDTypography variant="h5" sx={{color : "#4881ad"}}>
                        <Icon>star</Icon> Accès exclusif à la demande, à des produits de haute qualité
                      </MDTypography>
                      <MDTypography variant="body2">
                        En tant que partenaire de GRANITEX, vous bénéficiez d’un accès privilégié à une gamme de produits de haute qualité, spécifiquement 
                        adaptés à vos besoins. Ces produits, disponibles à la demande, sont conçus pour répondre aux standards les plus élevés du marché 
                        en matière de durabilité et de performance, assurant ainsi la satisfaction des clients les plus exigeants.
                      </MDTypography>
                    </MDBox>

                    <MDBox sx={{ marginBottom: '20px' }}>
                      <MDTypography variant="h5" sx={{color : "#4881ad"}}>
                        <Icon>info</Icon> Support marketing et promotionnel personnalisé
                      </MDTypography>
                      <MDTypography variant="body2">
                        Nous vous offrons un support marketing sur-mesure, adapté à vos besoins spécifiques. Que ce soit à travers des campagnes de 
                        communication ou du matériel promotionnel, nous mettons à votre disposition des outils efficaces pour maximiser vos ventes 
                        et renforcer votre image de marque, tout en vous aidant à conquérir de nouveaux marchés.
                      </MDTypography>
                    </MDBox>

                    <MDBox sx={{ marginBottom: '20px' }}>
                      <MDTypography variant="h5" sx={{color : "#4881ad"}}>
                        <Icon>local_library</Icon> Formation continue pour optimiser vos ventes
                      </MDTypography>
                      <MDTypography variant="body2" >
                        La formation est au cœur de notre approche. Nous vous proposons des formations continues, vous permettant de maîtriser 
                        l’utilisation de nos produits et de rester à la pointe des techniques de vente. Cette initiative vise à garantir que 
                        vos équipes soient toujours prêtes à maximiser leur efficacité et à répondre aux besoins de vos clients.
                      </MDTypography>
                    </MDBox>

                    <MDBox sx={{ marginBottom: '20px' }}>
                      <MDTypography variant="h5" sx={{color : "#4881ad"}}>
                        <Icon>support_agent</Icon> Service client réactif et dédié
                      </MDTypography>
                      <MDTypography variant="body2">
                        Notre service client est à votre écoute, prêt à répondre à toutes vos questions et à résoudre vos problèmes en temps réel. 
                        Un interlocuteur dédié vous est assigné pour assurer un suivi personnalisé, garantissant ainsi un accompagnement rapide et efficace.
                      </MDTypography>
                    </MDBox>

                    <MDBox sx={{ marginBottom: '20px' }}>
                      <MDTypography variant="h5" sx={{color : "#4881ad"}}>
                        <Icon>trending_up</Icon> Opportunités de croissance et d’expansion
                      </MDTypography>
                      <MDTypography variant="body2">
                        En partenariat avec GRANITEX, vous avez la possibilité de saisir de nombreuses opportunités de croissance. Grâce à notre 
                        expansion sur de nouveaux marchés et à l’évolution continue de notre gamme de produits, vous pouvez étendre vos activités 
                        et faire croître votre entreprise de manière durable et rentable.
                      </MDTypography>
                    </MDBox>
                </MDBox>
              </Grid>
              <Grid item xs={12} lg={4} sx={{ display: "flex" }} >
                <CallToAction />
              </Grid>
            </Grid>
        </MDBox>
      </MDBox>
    </Card>
    {pageContent.Contact && <LandingFooter data={pageContent.Contact} feed={pageContent.Features} limitTextToWords={limitTextToWords} about={pageContent.About} navBar={pageContent.Navigation?.navBar} logo={pageContent.Navigation.logo?.selectedImage} parseContent={parseContent}/>}
  </>
  )
}

export default Distributers